/**
 * Application constants
 */

export const APP_NAME = 'GoFood'
export const APP_VERSION = '0.0.0'

// Route names
export const ROUTES = {
  HOME: 'home',
  HOME_V2: 'home-v2',
  LOGIN: 'login',
  JOIN_NETWORK: 'join-network',
  POLICY: 'policy',
  PRIVACY: 'privacy',
  UNSUBSCRIBE: 'unsubscribe',
  SIGNAGE_TERMS: 'signage-terms',
  ACCESSIBILITY: 'accessibility',
  STORY: 'story',
  APP: 'app',
  CATALOG: 'catalog',
  CATALOG_IMMERSIVE: 'catalog-immersive',
  ADMIN_DASHBOARD: 'admin-dashboard',
  ADMIN_CATALOG: 'admin-catalog',
  ADMIN_DATA: 'admin-data',
  ADMIN_USERS: 'admin-users',
  ADMIN_CLIENTS: 'admin-clients',
  ADMIN_DEPARTMENTS: 'admin-departments',
  ADMIN_SUB_ITEMS: 'admin-sub-items',
  ADMIN_PROMOTIONS: 'admin-promotions',
  ADMIN_WHATSAPP: 'admin-whatsapp',
  ADMIN_LEVELS: 'admin-levels',
  ADMIN_ORDERS: 'admin-orders',
  ADMIN_ORDER_DETAILS: 'admin-order-details',
  ADMIN_CONTACT_FORMS: 'admin-contact-forms',
  ADMIN_B2B_FORMS: 'admin-b2b-forms',
  ADMIN_B2B_FORM_DETAILS: 'admin-b2b-form-details',
  ADMIN_B2B_DIVUR: 'admin-b2b-divur',
  ADMIN_CAMPAIGN_MANAGEMENT: 'admin-campaign-management',
  ADMIN_COMMITS: 'admin-commits',
  ADMIN_EMAILS: 'admin-emails',
  ADMIN_MAILING: 'admin-mailing',
  ADMIN_AGENT_REQUESTS: 'admin-agent-requests',
  ADMIN_SALES_ANALYSIS: 'admin-sales-analysis',
  ADMIN_AGENTS_SALES: 'admin-agents-sales',
  ADMIN_AGENT_ORDERS: 'admin-agent-orders',
  ADMIN_AGENT_ROUTE_TODAY: 'admin-agent-route-today',
  ADMIN_ATTENDANCE: 'admin-attendance',
  ADMIN_SALARY_WIZARD: 'admin-salary-wizard',
  ADMIN_DEVBLOG: 'admin-devblog',
  ADMIN_DEV_REQUESTS: 'admin-dev-requests',
  PROFILE: 'profile',
  AGENTS_PORTAL: 'agents-portal',
  AGENTS_CLIENTS: 'agents-clients',
  AGENTS_CLIENT_DETAILS: 'agents-client-details',
  AGENTS_CATALOG: 'agents-catalog',
  AGENTS_CATALOG_IMMERSIVE: 'agents-catalog-immersive',
  AGENTS_CREATE_CLIENT: 'agents-create-client',
  AGENTS_UPDATE_CLIENT: 'agents-update-client',
  AGENTS_GOALS: 'agents-goals',
  AGENTS_GVIA: 'agents-gvia',
  AGENTS_GVIA_SUCCESS: 'agents-gvia-success',
  AGENTS_HOLIDAYS: 'agents-holidays',
  AGENTS_STATISTICS: 'agents-statistics',
  AGENTS_REQUESTS: 'agents-requests',
  AGENTS_APP_TRANSFER: 'agents-app-transfer',
  AGENTS_PAYMENT_TERMS_REQUEST: 'agents-payment-terms-request',
  AGENTS_ATTENDANCE: 'agents-attendance',
  AGENTS_ROUTE_PLANNING: 'agents-route-planning',
  AGENTS_WALLET: 'agents-wallet',
  AGENTS_WALLET_PACKAGES: 'agents-wallet-packages',
  AGENTS_WALLET_BUCKET: 'agents-wallet-bucket',
  PROMOTION_DETAIL: 'promotion-detail',
  AGENTS_PROMOTION_DETAIL: 'agents-promotion-detail',
  QUANTITY_DISCOUNT: 'quantity-discount',
  AGENTS_QUANTITY_DISCOUNT: 'agents-quantity-discount',
  NOT_IN_ASSORTMENT: 'not-in-assortment',
  AGENTS_NOT_IN_ASSORTMENT: 'agents-not-in-assortment',
  ASSORTMENT_REQUEST: 'assortment-request',
  AGENTS_ASSORTMENT_REQUEST: 'agents-assortment-request',
  CHECKOUT: 'checkout',
  MY_ORDERS: 'my-orders',
  CONTACT: 'contact',
  PAYMENT_SUCCESS: 'payment-success',

  // Signage module
  SIGNAGE_DASHBOARD: 'signage-dashboard',
  SIGNAGE_EDITOR_NEW: 'signage-editor-new',
  SIGNAGE_EDITOR_EDIT: 'signage-editor-edit',
  SIGNAGE_SAVED: 'signage-saved',
  SIGNAGE_SETTINGS: 'signage-settings',
  ADMIN_SIGNAGE_SELECT: 'admin-signage-select',
}

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_PREFERENCES: 'user_preferences',
  THEME: 'theme',
  PENDING_ORDER: 'pending_order', // Stores order awaiting payment confirmation
  CATALOG_MODE_CHOICE: 'catalog_mode_choice', // 'normal' | 'immersive' — remembered chooser pick
}

// API timeouts
export const TIMEOUTS = {
  DEFAULT: 30000,
  LONG: 60000,
}

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
}
